// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__-xRoN","file":"styles_file__3Cjve"};